import { useTranslations } from 'next-intl';
import PostCard, { PostType } from '@/page-components/Blog/PostCard/PostCard';
import styles from './OtherBlogs.module.scss';
import Button, { ButtonType } from '@/components/Button/Button';

const OtherBlogsPost = ({ posts }: { posts: PostType[] }) => {
  const t = useTranslations('Blog');

  if (!posts || posts.length === 0) return null;

  return (
    <section className={styles.otherBlogs}>
      <div className={styles.otherBlogsHeader}>
        <h2>{t('OtherBlogs')}</h2>
        <div>
          <Button
            type={ButtonType.SECONDARY_LIGHT}
            href='/blog'
            iconName='arrow_forward'
          >
            {t('All publications')}
          </Button>
        </div>
      </div>
      <div className={styles.otherBlogsList}>
        {posts.slice(0, 3).map((post) => (
          <PostCard
            key={post.id}
            post={post}
          />
        ))}
      </div>
    </section>
  );
};

export default OtherBlogsPost;
